module.exports = __webpack_public_path__ + "static/media/14.c9428fe5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/14.svg
// module id = 126
// module chunks = 0